<script setup lang="ts">
import { NetworkIdType, getNetworkById } from '@sonarwatch/portfolio-core';
import BaseAddress from '@/components/molecules/BaseAddress.vue';
import { TagDetails } from '@/types';
import BaseNetworkIcon from '@/components/BaseNetworkIcon.vue';

const props = defineProps<{
  label?: string;
  networkId?: NetworkIdType;
  owner?: string;
  tags?: TagDetails[];
}>();
const network = props.networkId ? getNetworkById(props.networkId) : undefined;
const networkName = network ? network.name : undefined;
</script>

<template>
  <v-card>
    <v-card-subtitle class="mt-2 d-flex justify-space-between align-center">
      <div class="d-flex mt-2">
        <!-- @disabled-jup -->
        <!-- <v-chip v-if="networkId" size="small" class="mr-2 rounded-lg">
          <BaseNetworkIcon :networkId="networkId" :size="14"></BaseNetworkIcon>
          <span class="ml-2">
            {{ networkName }}
          </span>
        </v-chip> -->
        <v-chip v-if="label" size="small" class="mr-2 rounded-lg">
          {{ label }}
        </v-chip>
        <div v-if="tags && tags.length > 0">
          <v-chip
            v-for="(tag, i) in tags"
            :key="i"
            size="small"
            class="mr-2 rounded-lg"
            :color="tag.color || ''"
            :variant="tag.color ? 'flat' : 'tonal'"
          >
            <v-icon v-if="tag.icon" :icon="tag.icon" class="mr-1" />
            {{ tag.text }}
          </v-chip>
        </div>
      </div>
      <div class="ml-2 mt-2" v-if="owner">
        <BaseAddress
          class="text-caption text-medium-emphasis"
          :address="owner"
          force-short
          no-mono
          click-to-copy
        />
      </div>
      <v-spacer></v-spacer>
      <slot name="header"></slot>
    </v-card-subtitle>
    <v-card-text class="pa-0">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
